import { LogoBuilderActionTypes } from './logoBuilder.types';

export const initialState = {
  loading: false,
  available: undefined,
  logoGenerated: false,
  buildingLogo: false,
  clickOnMenu: false,
};

const logoBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    case LogoBuilderActionTypes.LOGO_BUILDER_AVAILABILITY_SET: {
      return {
        ...state,
        available: action.payload.available,
        buildingLogo: action.payload.buildingLogo,
      };
    }
    case LogoBuilderActionTypes.LOGO_BUILDER_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case LogoBuilderActionTypes.LOGO_BUILDER_LOGO_GENERATION_SUCCESS: {
      return {
        ...state,
        logoGenerated: true,
      };
    }
    case LogoBuilderActionTypes.LOGO_BUILDER_CLICKED_ON_MENU: {
      return {
        ...state,
        clickOnMenu: !state.clickOnMenu,
      };
    }
    default:
      return state;
  }
};

export default logoBuilderReducer;
